import api from "./api";

class CategoryService {
  /**************************************
   *  API FBO
   **************************************/
  async addCategory(params) {
    return await api
      .post("/blog/categories/create/", params)
      .then((response) => {
        return { status: response.status, data: response.data };
      })
      .catch(function (error) {
        return { status: error.response.status, data: error.response.data };
      });
  }

  async updateCategory(id, params) {
    return await api
      .put("/blog/categories/update/" + id + "/", params)
      .then((response) => {
        return { status: response.status, data: response.data };
      })
      .catch(function (error) {
        return { status: error.response.status, data: error.response.data };
      });
  }

  async getAllCategories(params) {
    return await api
      .get("/blog/categories/list", { params })
      .then((response) => {
        return { status: response.status, data: response.data };
      })
      .catch(function (error) {
        return { status: error.response.status, data: error.response.data };
      });
  }

  async getCategory(id) {
    return await api
      .get("/blog/categories/" + id)
      .then((response) => {
        return { status: response.status, data: response.data };
      })
      .catch(function (error) {
        return { status: error.response.status, data: error.response.data };
      });
  }

  async deleteCategory(id) {
    return await api
      .delete("/blog/categories/delete/" + id + "/")
      .then((response) => {
        return { status: response.status, data: response.data };
      })
      .catch(function (error) {
        return { status: error.response.status, data: error.response.data };
      });
  }

  async updateCategoriesOrder(categories) {
    return await api
      .post("/blog/categories/order/update", { categories })
      .then((response) => {
        return { status: response.status, data: response.data };
      })
      .catch((error) => {
        return {
          status: error.response?.status || 500,
          data: error.response?.data || { error: "Error inesperado" },
        };
      });
	}
}

export default new CategoryService();
